import request from '@/utils/request'

// 查询列表
export function apiScpMrpSuppliesSupplyDemandList (data) {
  return request({
    url: '/scp/scpMrpSupplies/supplyDemandList',
    method: 'post',
    data: data
  })
}

// 物料类别
export function apiScpMrpCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}
